<template>
  <div class="login">
    <!-- <div v-if="userInfo.userId">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <el-image
            class="head pc"
            fit="cover"
            src="https://www.ulearning.cn/common/img/defaultHeaderLg.png"
          ></el-image>
          <span class="name pc">{{ userInfo.name }}</span>
          <i class="iconfont iconiconfont02 mobile"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="homepage">我的首页</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
    <div>
      <i class="iconfont iconiconfont02 mobile" @click="goSjjx()"></i>
      <el-button class="viewMoreBtn" type="danger" size="small" plain
           @click="goSjjx()" >管理入口</el-button
          >
    </div>

    <el-dialog
      class="login-dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      width="380px"
    >
      <i class="iconfont iconguanbi" @click="dialogFormVisible = false"></i>
      <el-image class="banner" fit="cover" :src="require('@/assets/images/common/login-head.png')"></el-image>
      <form
        ref="loginForm"
        class="login-form"
        :action="formAction"
        method="post"
        @submit="login($event)"
      >
        <div class="form-title">登录</div>

        <el-input class="form-item" v-model="form.name" name="name" placeholder="用户名 / 手机号"></el-input>
        <el-input
          class="form-item"
          v-model="form.passwd"
          name="passwd"
          placeholder="请输入密码"
          show-password
        ></el-input>

        <el-input class="hide" v-model="form.checked" name="checked" type="hidden"></el-input>
        <el-input class="hide" v-model="form.redirectURL" name="redirectURL" type="hidden"></el-input>
        <el-input class="hide" v-model="form.isFrom" name="isFrom" type="hidden"></el-input>
        <el-input class="hide" v-model="form.newLocale" name="newLocale" type="hidden"></el-input>

        <div class="other-action">
          <el-link
            type="info"
            href="https://umobile.ulearning.cn/#/user/register"
            target="_blank"
          >立即注册</el-link>
          <el-link
            class="pull-right"
            type="info"
            href="https://umobile.ulearning.cn/#/user/findPassword"
            target="_blank"
          >忘记密码？</el-link>
        </div>

        <el-button class="login-btn" type="danger" native-type="submit">登录</el-button>
        <el-button class="login-btn wx-login-btn" type="success" plain @click="wxLogin">微信登录</el-button>
      </form>
    </el-dialog>
  </div>
</template>

<script>
import { checkUserForLogin } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "Login",
  data() {
    return {
      userInfo: {},
      dialogFormVisible: false,
      formAction: util.UMOOC_SERVER_HOST + "/umooc/user/login.do",
      form: {
        name: "",
        passwd: "",
        checked: ""
      }
    };
  },
  created() {
    let userInfo = util.getCookie("USER_INFO");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }
  },
  destroyed(){
    this.$EventBus.$off("showLoginFlag")
  },
  mounted(){
  this.$EventBus.$on("showLoginFlag",(msg)=>{
    this.dialogFormVisible=msg
  })
  },
  methods: {
    login(event) {
      if (this.form.checked) {
        this.form.checked = "";
        return true;
      }
      checkUserForLogin({
        loginname: this.form.name,
        password: this.form.passwd
      })
        .then(res => {
          if (res === 1) {
            this.form.checked = "1";
          } else if (res === 2) {
            // 需要手机验证码，暂不处理
            this.form.checked = "1";
          } else if (res === 3) {
            this.$message({
              showClose: true,
              message: "您已经连续输错5次，3分钟后重试",
              type: "warning"
            });
          } else {
            this.$message({
              showClose: true,
              message: "用户名/密码错误",
              type: "warning"
            });
          }

          if (this.form.checked) {
            this.$refs.loginForm.submit();
          }
        })
        .catch(err => {
          // 异常情况
          console.log(err);
        });

      event.preventDefault();
      return true;
    },
    register() {
      window.open("https://umobile.ulearning.cn/#/user/register");
    },
    wxLogin() {},
    handleCommand(command) {
      switch (command) {
        case "homepage":
          this.homePage();
          break;
        case "logout":
          this.logout();
          break;
        default:
      }
    },
    homePage() {
      switch (this.userInfo.roleId) {
        case 182:
        case 183:
          util.UMOOC_SERVER_HOST + "/admin";
          break;
        case 184:
          window.location =
            util.UMOOC_SERVER_HOST +
            "/umooc/service/service.do?operation=toolKit";
          break;
        case 250:
          window.location = `https://ua${util.UMOOC_COOKIE_DOMAIN}/createCourse/#/main/courseList/editing`;
          break;
        case 8:
          window.location =
            util.UMOOC_SERVER_HOST +
            "/umooc/tutorv2/tutorManage.do?operation=index";
          break;
        case 9:
          window.location =
            util.UMOOC_SERVER_HOST +
            "/umooc/learner/learner.do?operation=index";
          break;
        default:
          window.location =
            util.UMOOC_SERVER_HOST +
            "/umooc/learner/learner.do?operation=index";
      }
    },
    logout() {
      window.location =
        util.UMOOC_SERVER_HOST +
        "/umooc/home/logout.do?redirectUrl=" +
        encodeURIComponent(window.location.href);
    },
    goSjjx(){
      window.open("http://sjjx.tongshike.cn/pc/index.html#/login")
    }
  }
};
</script>

<style scoped>
.viewMoreBtn{
  background: rgba(255,255,255,0.10);
  opacity: 1;
  background-color: unset !important;
  border-color: #fff !important;
  color: #fff !important;
}
.viewMoreBtn:hover{
   background: rgba(255,255,255,0);
  opacity: 1;
  background-color: #fff !important;
  color: #B92E32 !important;
}
.login{
  padding-right: 20px;
}
.hide {
  display: none;
}

.head {
  margin-right: 10px;
  width: 32px;
  height: 32px;
  border-radius: 100%;
}
.head,
.name {
  vertical-align: middle;
}

.banner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.login-form {
  margin-top: 90px;
}

.form-title {
  padding-top: 10px;
  line-height: 32px;
  font-size: 18px;
  text-align: center;
}

.form-item {
  margin-top: 10px;
}

.other-action {
  margin-top: 10px;
}

.pull-right {
  float: right;
}

.login-btn {
  display: block;
  margin-top: 15px;
  width: 100%;
}

.wx-login-btn {
  margin-left: 0 !important;
}

.iconfont {
  font-size: 24px;
  color: #888;
}

.iconguanbi {
  position: absolute;
  z-index: 2;
  top: 16px;
  right: 16px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
</style>

<style lang="scss">
.login-dialog {
  .el-dialog {
    max-width: 90%;
  }
}
</style>